<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OrJPIX/tc-custom/9781605098388.jpg?1695307524556" alt="This image is the cover for the book Female Vision"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Female Vision
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This groundbreaking study reveals the vital perspective women bring to business—and how to make sure your organization takes full advantage of it.</b></p><p>Women and men experience the world differently. They not only see things differently—they also see different things. Men tend to have a bottom line, linear way of thinking. Women are more empathetic, more aware of the critical impact of interpersonal factors both within and without the organization. Everyone knows that both perspectives are important, yet organizations only reward traditionally male points of view.</p><p>Drawing on extensive research and workplace experience, Sally Helgesen and Julie Johnson demonstrate that the female perspective is the underutilized asset so many companies need to succeed. They delve into the stories of women whose vision improved their companies—even as they had to struggle against unresponsive organizations, dismissive managers, and their own personal fears. </p><i>The Female Vision</i> also show how companies can create environments that welcome and encourage women to share what they notice, to the benefit of the organization as a whole—including the bottom line.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally Helgesen, Julie Johnson, Marshall Goldsmith
      </h2>
      
      <p class="authorDescription body article">Sally Helgesen is a renowned speaker and the author of five books, including the classic bestseller The Female Advantage and The Web of Inclusion.</P><br/><br/><P>Julie Johnson, a graduate of Harvard Business School, is a pioneer in the field of executive coaching and has coached many of the most successful women in the Fortune 500.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publisher, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd3c3b46